module.exports = __webpack_public_path__ + "media/assets/images/post-bg/post-bg-2-5d8fb18f948695ec29ac0f5035be3c47.jpg";